export const ApplicationBrand = {
  brandName: 'E-TRaide',
  subBrandName: '',
  brandImage: '/brand.png',
};

export const MenuItems = {
  "applicationItem": {
    "data": {
      parentID: 1,
      item: [
        {
          id: '1',
          name: "Dashboard",
          icon: "/Images/carbon--analytics.svg",
          path: "/dashboard"
        },
        {
          id: '2',
          name: "Planning",
          icon: "/Images/solar--calendar-line-duotone.svg",
          path: "/planning"
        },
        {
          id: '3',
          name: "Coverage",
          icon: "/Images/streamline--information-desk-customer-solid.svg",
          path: "/coverage"
        },
        {
          id: '4',
          name: "Orders",
          icon: "/Images/streamline--task-list.svg",
          path: "/order"
        }
      ]
    }
  }
};

export const ApplicationItems = {
  "applications": [
    {
      name: "Sales Analytics",
      icon: "/Images/graph-bar.svg",
      modules: [
        {
          id: 1,
          name: "Dashboard",
          icon: "/Images/dashboard.svg",
          roleLevel: "0",
          path: "/dashboards",
          children: [
            {
              menuHeader: "Sales Reports (Salesforce)"
            },
            {
              id: 1,
              name: "Comparative Sales Performance",
              icon: "/Images/graph-bar.svg",
              roleLevel: "0",
              path: "/dashboards"
            },
            {
              menuHeader: "Product Sales Reports"
            },
            {
              id: 3,
              name: "Performance by Product Group",
              icon: "/Images/desk-customer.svg",
              roleLevel: "0",
              path: "/dashboards"
            },
            {
              id: 4,
              name: "Comparative Sales",
              icon: "/Images/desk-customer.svg",
              roleLevel: "0",
              path: "/dashboards"
            },
            {
              id: 7,
              name: "Customer Group Product",
              icon: "/Images/product.svg",
              roleLevel: "0",
              path: "/dashboards"
            },
            {
              id: 'products',
              name: "Product Performance Y o Y",
              icon: "/Images/product.svg",
              roleLevel: "4",
              path: "/data/historical"
            },
            {
              menuHeader: "Customer Sales Reports"
            },
            {
              id: 5,
              name: "Growth Performance",
              icon: "/Images/desk-customer.svg",
              roleLevel: "0",
              path: "/dashboards"
            },
            {
              id: 6,
              name: "Customer Sales",
              icon: "/Images/desk-customer.svg",
              roleLevel: "0",
              path: "/dashboards"
            },
            {
              menuHeader: "Quick Views",
              roleLevel: "4"
            },
            {
              id: 'regions',
              name: "Regions",
              icon: "/Images/regions.svg",
              roleLevel: "4",
              path: "/list"
            },
            {
              id: 'dms',
              name: "District Managers",
              icon: "/Images/districts.svg",
              roleLevel: "2",
              path: "/list"
            },
            {
              id: 'employees',
              name: "PMRs",
              icon: "/Images/employees.svg",
              roleLevel: "1",
              path: "/list"
            },
            // {
            //   id: 'c-groups',
            //   name: "Customer Groups",
            //   icon: "/Images/desk-customer.svg",
            //   roleLevel: "0",
            //   path: "/list"
            // },
            {
              id: 'p-groups',
              name: "Product Groups",
              icon: "/Images/product-group.svg",
              roleLevel: "0",
              path: "/list"
            },
            {
              id: 'products',
              name: "Products",
              icon: "/Images/product.svg",
              roleLevel: "0",
              path: "/list"
            }
          ]
        }
      ]
    }
  ]
}